module.exports = __webpack_public_path__ + "static/media/whychoose_2.9aaecfc8.jpg";